<div tabindex="7" class="details text-end m-2" (blur)="onBlur($event)">
  <mat-card>
    <mat-card-title>{{user.attributes.name}}</mat-card-title>
    <mat-card-subtitle>
      @for (role of roles; track role) {
        {{role}},
      }
    </mat-card-subtitle>
    <mat-card-content>
      {{user.attributes.email}}
      {{user.attributes.phone_number}}
    </mat-card-content>
    <mat-card-actions>
      <mat-divider></mat-divider>
      <button class="mt-2" (click)="signOut()" mat-stroked-button>
        Sign out
      </button>
    </mat-card-actions>
  </mat-card>
</div>
